
// import React, { useState, useEffect, useRef } from "react";
// import { useNavigate } from "react-router-dom";
// import { AiOutlineMenu } from "react-icons/ai";
// import { IoIosArrowDown } from "react-icons/io";
// import { FiUser, FiLogOut, FiLock, FiDownload } from "react-icons/fi";
// import { Link } from "react-router-dom";
// import { Modal, Button, Form } from "react-bootstrap";
// import { FaBell } from "react-icons/fa";
// import wallet from "../assets/images/wallet.png";

// const API_URL = process.env.REACT_APP_API_URL;

// function Header({ onToggleSidebar }) {
//   const [dropdownOpen, setDropdownOpen] = useState(false);
//   const navigate = useNavigate();
//   const dropdownRef = useRef(null);
//   const [name, setName] = useState("");
//   const [currentPassword, setCurrentPassword] = useState("");
//   const [userEmail, setuserEmail] = useState("");
//   const [showChangePasswordModal, setShowChangePasswordModal] = useState(false);
//   const [showProfileModal, setShowProfileModal] = useState(false);
//   // const [newPassword, setNewPassword] = useState("");
//   // const [confirmNewPassword, setConfirmNewPassword] = useState("");

//   const [newPassword, setNewPassword] = useState("");
// const [confirmNewPassword, setConfirmNewPassword] = useState("");
// const [showNewPassword, setShowNewPassword] = useState(false);
// const [showConfirmPassword, setShowConfirmPassword] = useState(false);

//   const [passwordErrors, setPasswordErrors] = useState({});
//   const [profile, setProfile] = useState({});
//   const [isPasswordChanging, setIsPasswordChanging] = useState(false);
//   const [showMessageModal, setShowMessageModal] = useState(false);
//   const [notifications, setNotifications] = useState([]);
//   const [unreadCount, setUnreadCount] = useState(0);
//   const [messageModalContent, setMessageModalContent] = useState({
//     title: "",
//     text: "",
//     type: "",
//     confirmAction: null,
//   });

//   const showCustomMessageModal = (title, text, type, confirmAction = null) => {
//     setMessageModalContent({ title, text, type, confirmAction });
//     setShowMessageModal(true);
//   };

//   const closeCustomMessageModal = () => {
//     setShowMessageModal(false);
//     setMessageModalContent({
//       title: "",
//       text: "",
//       type: "",
//       confirmAction: null,
//     });
//   };

//   const getAuthToken = () => localStorage.getItem("token");

//   const fetchProfile = async () => {
//     try {
//       const token = getAuthToken();
//       const response = await fetch(`${API_URL}/profile`, {
//         method: "GET",
//         headers: {
//           "Content-Type": "application/json",
//           Authorization: `Bearer ${token}`,
//         },
//       });
//       const data = await response.json();

//       setCurrentPassword(data.data.password);

//       let userName = data.data.name;
//       if (!userName || userName === "") {
//         const email = data.data.email;
//         if (email) {
//           userName = email.split("@")[0];
//         } else {
//           userName = "Admin";
//         }
//       }

//       setName(userName);
//       setuserEmail(data.data.email);
//     } catch (err) {
//       console.error("Fetch Profile error:", err);
//     }
//   };

//   const fetchCount = async () => {
//     try {
//       const token = getAuthToken();
//       const response = await fetch(`${API_URL}/notification-count`, {
//         method: "GET",
//         headers: {
//           "Content-Type": "application/json",
//           Authorization: `Bearer ${token}`,
//         },
//       });

//       const data = await response.json();
//       setUnreadCount(data.data?.[0]?.unseen_count || 0);
//     } catch (err) {
//       console.error("Fetch Profile error:", err);
//     }
//   };

//   useEffect(() => {
//     fetchCount();
//     fetchProfile();
//   }, []);

//   const handleBellClick = () => {
//     setUnreadCount(0);
//     navigate("/notification-list");
//   };

//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
//         setDropdownOpen(false);
//       }
//     };
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => document.removeEventListener("mousedown", handleClickOutside);
//   }, []);

//   const toggleDropdown = () => setDropdownOpen(!dropdownOpen);

//   const handleLogout = () => {
//     localStorage.clear();
//     sessionStorage.clear();
//     window.location.href = "/login";
//   };

//   const handleShowProfileModal = () => {
//     setShowProfileModal(true);
//     setDropdownOpen(false);
//   };

//   const handleShowChangePasswordModal = () => {
//     setNewPassword("");
//     setConfirmNewPassword("");
//     setPasswordErrors({});
//     setShowChangePasswordModal(true);
//     setDropdownOpen(false);
//   };

//   const handleCloseProfileModal = () => setShowProfileModal(false);
//   const handleCloseChangePasswordModal = () => setShowChangePasswordModal(false);

//   const validatePasswordForm = () => {
//     const errors = {};
//     if (!newPassword) {
//       errors.newPassword = "New password is required.";
//     } else if (newPassword.length < 6) {
//       errors.newPassword = "Password must be at least 6 characters long.";
//     }
//     if (!confirmNewPassword) {
//       errors.confirmNewPassword = "Confirm password is required.";
//     }
//     if (
//       newPassword &&
//       confirmNewPassword &&
//       newPassword !== confirmNewPassword
//     ) {
//       errors.confirmNewPassword =
//         "New password and confirm password do not match";
//     }
//     setPasswordErrors(errors);
//     return Object.keys(errors).length === 0;
//   };

//   const handleChangePassword = async (e) => {
//     e.preventDefault();
//     if (!validatePasswordForm()) return;
//     setIsPasswordChanging(true);
//     try {
//       const token = getAuthToken();
//       if (!token) {
//         setIsPasswordChanging(false);
//         showCustomMessageModal(
//           "Authentication Error",
//           "No authentication token found. Please log in again.",
//           "error",
//         );
//         return;
//       }
//       const response = await fetch(`${API_URL}/change-password`, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//           Authorization: `Bearer ${token}`,
//         },
//         body: JSON.stringify({ password: newPassword, name: name }),
//       });
//       if (response.ok) {
//         const result = await response.json();
//         showCustomMessageModal(
//           result.message || "Password changed successfully!",
//           "success",
//         );
//         handleCloseChangePasswordModal();
//         fetchProfile();
//       } else {
//         const errorData = await response.json();
//         showCustomMessageModal(
//           `Error: ${errorData.message || "Failed to change password."}`,
//           "error",
//         );
//       }
//     } catch (error) {
//       showCustomMessageModal(
//         `An unexpected error occurred: ${error.message}`,
//         "error",
//       );
//     } finally {
//       setIsPasswordChanging(false);
//     }
//   };

//   useEffect(() => {
//     const socket = new WebSocket(process.env.REACT_APP_WS_URL);

//     socket.onopen = () => {
//       const token = localStorage.getItem("token");
//       if (token) {
//         socket.send(JSON.stringify({ type: "auth", token }));
//       }
//     };

//     socket.onmessage = (event) => {
//       try {
//         const data = JSON.parse(event.data);
//         if (data.event === "receive_message") {
//           if (Array.isArray(data.rows)) {
//             setNotifications((prev) => [...data.rows, ...prev]);
//           }
//           fetchCount();
//         }
//         if (data.event === "notification_count") {
//           setUnreadCount(data.count || 0);
//         }
//       } catch (err) {
//         console.error("Socket parse error:", err);
//       }
//     };

//     socket.onclose = () => { };

//     return () => {
//       socket.close();
//     };
//   }, []);

//   const [deferredPrompt, setDeferredPrompt] = useState(null);
//   const [showInstall, setShowInstall] = useState(true);

//   useEffect(() => {
//     const handler = (e) => {
//       e.preventDefault();
//       setDeferredPrompt(e);
//       setShowInstall(true);
//     };
//     window.addEventListener("beforeinstallprompt", handler);
//     return () => {
//       window.removeEventListener("beforeinstallprompt", handler);
//     };
//   }, []);

//   const handleInstallClick = async () => {
//     if (!deferredPrompt) {
//       alert(
//         "Install prompt not available. Try in Chrome/Edge on localhost or HTTPS.",
//       );
//       return;
//     }
//     deferredPrompt.prompt();
//     const { outcome } = await deferredPrompt.userChoice;
//     if (outcome === "accepted") {
//       alert("App installed successfully ✅");
//     } else {
//       alert("Installation dismissed ❌");
//     }
//     setDeferredPrompt(null);
//     setShowInstall(false);
//   };

//   return (
//     <div className="header" id="header">
//       <div className="d-flex justify-content-between px-2 w-100 gap-1">
//         {/* 🔴 LEFT SIDE */}
//         <div className="header-left d-flex align-items-center gap-2">
//           {/* Toggle */}
//           <div className="togglebutton" onClick={onToggleSidebar}>
//             <AiOutlineMenu />
//           </div>

//           {/* Logo — Mobile Only */}
//           <div className="logo-box d-xl-none d-md-none d-sm-block">
//             <Link className="logo-light" to="/dashboard">
//               <img
//                 src={`${process.env.PUBLIC_URL}/assets/images/logo.png`}
//                 alt="logo"
//                 className="logo-lg"
//               />
//             </Link>
//           </div>

//           {/* Wallet Ledger */}
//           <div className="desktop-show">
//             <div className="d-flex align-items-center flex-wrap gap-2">
//               {localStorage.getItem("userType") === "admin" && (
//                 <div className="wallet">
//                   <div className="credit_amount">
//                     <Link
//                       to="/admin-wallet-report"
//                       className="gap-2 wallet-link d-flex align-items-center text-decoration-none"
//                     >
//                       <div className="walletimage">
//                         <img src={wallet} alt="wallet" />
//                       </div>
//                       <div className="text-dark">
//                         <div className="referdetailscontent text-center">
//                           <p className="mb-1 d-none d-md-block">Wallet Ledger</p>
//                         </div>
//                       </div>
//                     </Link>
//                   </div>
//                 </div>
//               )}
//             </div>
//           </div>
//         </div>

//         {/* 🔴 RIGHT SIDE */}
//         <div className="linksmode">
//           {/* Bell */}
//           {localStorage.getItem("userType") === "admin" && (
//             <div className="d-xl-block position-relative">
//               <div
//                 className="allheader border-0"
//                 onClick={handleBellClick}
//                 style={{ cursor: "pointer" }}
//               >
//                 <FaBell />
//                 <span className="badge bg-danger position-absolute top-0 start-100 translate-middle">
//                   {unreadCount ?? 0}
//                 </span>
//               </div>
//             </div>
//           )}

//           {/* Profile */}
//           <div className="profilie" ref={dropdownRef}>
//             <div className="profile-header" onClick={toggleDropdown}>
//               <div className="profileimage">
//                 <img
//                   src={
//                     profile?.avatar ||
//                     `${process.env.PUBLIC_URL}/assets/images/avatar-1.jpg`
//                   }
//                   alt="Admin"
//                   onError={(e) => {
//                     e.target.src = `https://ui-avatars.com/api/?name=Admin&background=1e5799&color=fff&bold=true`;
//                   }}
//                 />
//               </div>
//               <div className="name desktop_device">
//                 {name || userEmail?.split("@")[0] || "Admin"}
//               </div>
//               <div
//                 className={`arrowprofile transition-transform duration-300 ${dropdownOpen ? "rotate-180" : ""
//                   }`}
//               >
//                 <IoIosArrowDown />
//               </div>
//             </div>

//             {dropdownOpen && (
//               <div className="profile-dropdown">
//                 {/* User Info — Mobile Only */}
//                 <div className="dropdown-item mobile_device">
//                   <div className="d-flex gap-2 align-items-center">
//                     <div className="profileimage">
//                       <img
//                         src={`https://ui-avatars.com/api/?name=Admin&background=1e5799&color=fff&bold=true`}
//                         alt="Admin"
//                       />
//                     </div>
//                     <div className="name">
//                       {name || userEmail?.split("@")[0] || "Admin"}
//                     </div>
//                   </div>
//                 </div>

//                 {/* Install App — Mobile Only */}
//                 {showInstall && (
//                   <div
//                     className="dropdown-item d-flex align-items-center gap-2 mobile-pwa"
//                     onClick={handleInstallClick}
//                   >
//                     <FiDownload />
//                     Install App
//                   </div>
//                 )}

//                 {/* Profile */}
//                 <div
//                   className="dropdown-item d-flex align-items-center gap-2"
//                   onClick={handleShowProfileModal}
//                 >
//                   <FiUser />
//                   Profile
//                 </div>

//                 {/* Change Password */}
//                 <div
//                   className="dropdown-item d-flex align-items-center gap-2"
//                   onClick={handleShowChangePasswordModal}
//                 >
//                   <FiLock />
//                   Change Password
//                 </div>

//                 {/* Logout */}
//                 <div
//                   className="dropdown-item d-flex align-items-center gap-2 text-danger fw-bold"
//                   onClick={handleLogout}
//                 >
//                   <FiLogOut />
//                   Logout
//                 </div>
//               </div>
//             )}
//           </div>
//         </div>
//       </div>

//       {/* Profile Modal */}
//       {/* <Modal show={showProfileModal} onHide={handleCloseProfileModal} centered>
//         <Modal.Header closeButton>
//           <Modal.Title>Profile Information</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <Form>
//             <Form.Group className="mb-3" controlId="userNameDisplay">
//               <Form.Label>Name</Form.Label>
//               <Form.Control
//                 type="text"
//                 value={name || userEmail?.split("@")[0] || "Admin"}
//                 readOnly
//               />
//             </Form.Group>
//             <Form.Group className="mb-3" controlId="userEmailDisplay">
//               <Form.Label>Email</Form.Label>
//               <Form.Control type="text" value={userEmail} readOnly />
//             </Form.Group>
//           </Form>
//         </Modal.Body>
//         <Modal.Footer>
//           <Button variant="primary" onClick={handleCloseProfileModal}>
//             Close
//           </Button>
//         </Modal.Footer>
//       </Modal> */}

//       {/* Profile Modal */}
//       <Modal show={showProfileModal} onHide={handleCloseProfileModal} centered>
//         <Modal.Header
//           closeButton
//           style={{
//             background: "linear-gradient(135deg, #1e5799, #2b6cb0)",
//             color: "#ffffff",
//             borderTopLeftRadius: "12px",
//             borderTopRightRadius: "12px",
//             borderBottom: "none",
//             padding: "16px 20px",
//           }}
//         >
//           <Modal.Title
//             style={{
//               fontSize: "18px",
//               fontWeight: "700",
//               letterSpacing: "-0.3px",
//             }}
//           >
//             👤 Profile Information
//           </Modal.Title>
//         </Modal.Header>

//         <Modal.Body style={{ padding: "24px" }}>
//           {/* Avatar + Name Section */}
//           <div
//             style={{
//               display: "flex",
//               alignItems: "center",
//               gap: "16px",
//               marginBottom: "24px",
//               paddingBottom: "20px",
//               borderBottom: "1.5px solid #e2e8f0",
//             }}
//           >
//             <img
//               src={`https://ui-avatars.com/api/?name=${encodeURIComponent(
//                 name || "Admin",
//               )}&background=1e5799&color=fff&bold=true&size=80`}
//               alt="Admin"
//               style={{
//                 width: "70px",
//                 height: "70px",
//                 borderRadius: "50%",
//                 border: "3px solid #e2e8f0",
//                 boxShadow: "0 4px 12px rgba(30, 87, 153, 0.15)",
//               }}
//               onError={(e) => {
//                 e.target.src = `https://ui-avatars.com/api/?name=Admin&background=1e5799&color=fff&bold=true&size=80`;
//               }}
//             />
//             <div>
//               <h5
//                 style={{
//                   margin: 0,
//                   fontSize: "18px",
//                   fontWeight: "700",
//                   color: "#1e3a5f",
//                 }}
//               >
//                 {name || userEmail?.split("@")[0] || "Admin"}
//               </h5>
//               <p
//                 style={{
//                   margin: "4px 0 0",
//                   fontSize: "13px",
//                   color: "#64748b",
//                   fontWeight: "500",
//                 }}
//               >
//                 {userEmail || "—"}
//               </p>
//               <span
//                 style={{
//                   display: "inline-block",
//                   marginTop: "6px",
//                   padding: "3px 10px",
//                   borderRadius: "20px",
//                   fontSize: "11px",
//                   fontWeight: "700",
//                   background: "linear-gradient(135deg, #1e5799, #2b6cb0)",
//                   color: "#ffffff",
//                   letterSpacing: "0.5px",
//                 }}
//               >
//                 ADMIN
//               </span>
//             </div>
//           </div>

//           {/* Form Fields */}
//           <Form>
//             <Form.Group className="mb-3" controlId="userNameDisplay">
//               <Form.Label
//                 style={{
//                   fontSize: "12.5px",
//                   fontWeight: "700",
//                   color: "#1e3a5f",
//                   marginBottom: "6px",
//                   display: "flex",
//                   alignItems: "center",
//                   gap: "6px",
//                 }}
//               >
//                 👤 Name
//               </Form.Label>
//               <Form.Control
//                 type="text"
//                 value={name || userEmail?.split("@")[0] || "Admin"}
//                 readOnly
//                 style={{
//                   borderRadius: "10px",
//                   padding: "10px 14px",
//                   fontSize: "14px",
//                   fontWeight: "600",
//                   color: "#1e3a5f",
//                   background: "#f8fafc",
//                   border: "1.5px solid #e2e8f0",
//                 }}
//               />
//             </Form.Group>

//             <Form.Group className="mb-2" controlId="userEmailDisplay">
//               <Form.Label
//                 style={{
//                   fontSize: "12.5px",
//                   fontWeight: "700",
//                   color: "#1e3a5f",
//                   marginBottom: "6px",
//                   display: "flex",
//                   alignItems: "center",
//                   gap: "6px",
//                 }}
//               >
//                 ✉️ Email
//               </Form.Label>
//               <Form.Control
//                 type="text"
//                 value={userEmail || "—"}
//                 readOnly
//                 style={{
//                   borderRadius: "10px",
//                   padding: "10px 14px",
//                   fontSize: "14px",
//                   fontWeight: "600",
//                   color: "#1e3a5f",
//                   background: "#f8fafc",
//                   border: "1.5px solid #e2e8f0",
//                 }}
//               />
//             </Form.Group>
//           </Form>
//         </Modal.Body>

//         <Modal.Footer
//           style={{
//             borderTop: "1.5px solid #e2e8f0",
//             padding: "16px 24px",
//             background: "#f8fafc",
//             borderBottomLeftRadius: "12px",
//             borderBottomRightRadius: "12px",
//           }}
//         >
//           <Button
//             onClick={handleCloseProfileModal}
//             style={{
//               borderRadius: "10px",
//               fontWeight: "700",
//               padding: "9px 24px",
//               background: "linear-gradient(135deg, #1e5799, #2b6cb0)",
//               border: "none",
//               color: "#ffffff",
//               boxShadow: "0 4px 12px rgba(30, 87, 153, 0.25)",
//             }}
//           >
//             Close
//           </Button>
//         </Modal.Footer>
//       </Modal>

//       {/* Change Password Modal */}
//       <Modal
//         show={showChangePasswordModal}
//         onHide={handleCloseChangePasswordModal}
//         centered
//       >
//         <Modal.Header closeButton>
//           <Modal.Title>Change Password</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <Form onSubmit={handleChangePassword}>
//             <Form.Group className="mb-3" controlId="newPassword">
//               <Form.Label>New Password</Form.Label>
//               <Form.Control
//                 type="password"
//                 value={newPassword}
//                 onChange={(e) => {
//                   setNewPassword(e.target.value);
//                   if (passwordErrors.newPassword)
//                     setPasswordErrors((prev) => ({
//                       ...prev,
//                       newPassword: null,
//                     }));
//                 }}
//                 isInvalid={!!passwordErrors.newPassword}
//                 placeholder="Enter new password"
//               />
//               <Form.Control.Feedback type="invalid">
//                 {passwordErrors.newPassword}
//               </Form.Control.Feedback>
//             </Form.Group>
//             <Form.Group className="mb-3" controlId="confirmNewPassword">
//               <Form.Label>Confirm New Password</Form.Label>
//               <Form.Control
//                 type="password"
//                 value={confirmNewPassword}
//                 onChange={(e) => {
//                   setConfirmNewPassword(e.target.value);
//                   if (passwordErrors.confirmNewPassword)
//                     setPasswordErrors((prev) => ({
//                       ...prev,
//                       confirmNewPassword: null,
//                     }));
//                 }}
//                 isInvalid={!!passwordErrors.confirmNewPassword}
//                 placeholder="Confirm new password"
//               />
//               <Form.Control.Feedback type="invalid">
//                 {passwordErrors.confirmNewPassword}
//               </Form.Control.Feedback>
//             </Form.Group>
//             <Button
//               variant="primary"
//               type="submit"
//               className="w-100"
//               disabled={isPasswordChanging}
//             >
//               {isPasswordChanging ? "Changing..." : "Change Password"}
//             </Button>
//           </Form>
//         </Modal.Body>
//       </Modal>

//       {/* Message Modal */}
//       {showMessageModal && (
//         <div
//           className="modal d-block"
//           tabIndex="-1"
//           style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
//         >
//           <div className="modal-dialog modal-dialog-centered">
//             <div
//               className={`modal-content ${messageModalContent.type === "success" ? "border-success" : ""
//                 }`}
//             >
//               <div className="modal-header d-flex justify-content-between align-items-center">
//                 <h5
//                   className={`modal-title ${messageModalContent.type === "success"
//                       ? "text-success"
//                       : messageModalContent.type === "error"
//                         ? "text-danger"
//                         : "text-warning"
//                     }`}
//                 >
//                   {messageModalContent.title}
//                 </h5>
//                 <button
//                   type="button"
//                   className="btn-close"
//                   aria-label="Close"
//                   onClick={closeCustomMessageModal}
//                 ></button>
//               </div>
//               <div className="modal-body text-secondary">
//                 <p>{messageModalContent.text}</p>
//               </div>
//               <div className="modal-footer justify-content-center">
//                 {messageModalContent.confirmAction ? (
//                   <>
//                     <Button
//                       variant="secondary"
//                       onClick={closeCustomMessageModal}
//                     >
//                       Cancel
//                     </Button>
//                     <Button
//                       variant={
//                         messageModalContent.type === "warning"
//                           ? "warning"
//                           : "primary"
//                       }
//                       onClick={() => {
//                         messageModalContent.confirmAction();
//                         closeCustomMessageModal();
//                       }}
//                     >
//                       Confirm
//                     </Button>
//                   </>
//                 ) : (
//                   <Button
//                     variant={
//                       messageModalContent.type === "success"
//                         ? "success"
//                         : messageModalContent.type === "error"
//                           ? "danger"
//                           : "primary"
//                     }
//                     onClick={closeCustomMessageModal}
//                   >
//                     OK
//                   </Button>
//                 )}
//               </div>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }

// export default Header;

import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { AiOutlineMenu } from "react-icons/ai";
import { IoIosArrowDown } from "react-icons/io";
import { FiUser, FiLogOut, FiLock, FiDownload } from "react-icons/fi";
import { Link } from "react-router-dom";
import { Modal, Button, Form } from "react-bootstrap";
import { FaBell } from "react-icons/fa";
import wallet from "../assets/images/wallet.png";

const API_URL = process.env.REACT_APP_API_URL;

function Header({ onToggleSidebar }) {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const navigate = useNavigate();
  const dropdownRef = useRef(null);
  const [name, setName] = useState("");
  const [currentPassword, setCurrentPassword] = useState("");
  const [userEmail, setuserEmail] = useState("");
  const [showChangePasswordModal, setShowChangePasswordModal] = useState(false);
  const [showProfileModal, setShowProfileModal] = useState(false);
  const [newPassword, setNewPassword] = useState("");
  const [confirmNewPassword, setConfirmNewPassword] = useState("");
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [passwordErrors, setPasswordErrors] = useState({});
  const [profile, setProfile] = useState({});
  const [isPasswordChanging, setIsPasswordChanging] = useState(false);
  const [showMessageModal, setShowMessageModal] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const [unreadCount, setUnreadCount] = useState(0);

  // 🎯 TOAST STATE
  const [toast, setToast] = useState({
    show: false,
    title: "",
    text: "",
    type: "success",
  });

  const [messageModalContent, setMessageModalContent] = useState({
    title: "",
    text: "",
    type: "",
    confirmAction: null,
  });

  // 🎯 SHOW TOAST (replaces old modal for simple success/error)
  const showToast = (title, text, type = "success") => {
    setToast({ show: true, title, text, type });
    setTimeout(() => {
      setToast({ show: false, title: "", text: "", type: "success" });
    }, 5000);
  };

  // Keep old modal for confirm actions (like delete)
  const showCustomMessageModal = (title, text, type, confirmAction = null) => {
    setMessageModalContent({ title, text, type, confirmAction });
    setShowMessageModal(true);
  };

  const closeCustomMessageModal = () => {
    setShowMessageModal(false);
    setMessageModalContent({
      title: "",
      text: "",
      type: "",
      confirmAction: null,
    });
  };

  const getAuthToken = () => localStorage.getItem("token");

  const fetchProfile = async () => {
    try {
      const token = getAuthToken();
      const response = await fetch(`${API_URL}/profile`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      const data = await response.json();

      setCurrentPassword(data.data.password);

      let userName = data.data.name;
      if (!userName || userName === "") {
        const email = data.data.email;
        if (email) {
          userName = email.split("@")[0];
        } else {
          userName = "Admin";
        }
      }

      setName(userName);
      setuserEmail(data.data.email);
    } catch (err) {
      console.error("Fetch Profile error:", err);
    }
  };

  const fetchCount = async () => {
    try {
      const token = getAuthToken();
      const response = await fetch(`${API_URL}/notification-count`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      const data = await response.json();
      setUnreadCount(data.data?.[0]?.unseen_count || 0);
    } catch (err) {
      console.error("Fetch Profile error:", err);
    }
  };

  useEffect(() => {
    fetchCount();
    fetchProfile();
  }, []);

  const handleBellClick = () => {
    setUnreadCount(0);
    navigate("/notification-list");
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const toggleDropdown = () => setDropdownOpen(!dropdownOpen);

  const handleLogout = () => {
    localStorage.clear();
    sessionStorage.clear();
    window.location.href = "/login";
  };

  const handleShowProfileModal = () => {
    setShowProfileModal(true);
    setDropdownOpen(false);
  };

  const handleShowChangePasswordModal = () => {
    setNewPassword("");
    setConfirmNewPassword("");
    setPasswordErrors({});
    setShowChangePasswordModal(true);
    setDropdownOpen(false);
  };

  const handleCloseProfileModal = () => setShowProfileModal(false);
  const handleCloseChangePasswordModal = () => setShowChangePasswordModal(false);

  const validatePasswordForm = () => {
    const errors = {};
    if (!newPassword) {
      errors.newPassword = "New password is required.";
    } else if (newPassword.length < 6) {
      errors.newPassword = "Password must be at least 6 characters long.";
    }
    if (!confirmNewPassword) {
      errors.confirmNewPassword = "Confirm password is required.";
    }
    if (
      newPassword &&
      confirmNewPassword &&
      newPassword !== confirmNewPassword
    ) {
      errors.confirmNewPassword =
        "New password and confirm password do not match";
    }
    setPasswordErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleChangePassword = async (e) => {
    e.preventDefault();
    if (!validatePasswordForm()) return;
    setIsPasswordChanging(true);
    try {
      const token = getAuthToken();
      if (!token) {
        setIsPasswordChanging(false);
        showToast(
          "Authentication Error",
          "No authentication token found. Please log in again.",
          "error",
        );
        return;
      }
      const response = await fetch(`${API_URL}/change-password`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ password: newPassword, name: name }),
      });
      if (response.ok) {
        const result = await response.json();

        // ✅ Beautiful toast
        showToast(
          "Success!",
          result.message || "Password changed successfully!",
          "success",
        );

        handleCloseChangePasswordModal();
        fetchProfile();
      } else {
        const errorData = await response.json();
        showToast(
          "Error!",
          errorData.message || "Failed to change password.",
          "error",
        );
      }
    } catch (error) {
      showToast(
        "Error!",
        `An unexpected error occurred: ${error.message}`,
        "error",
      );
    } finally {
      setIsPasswordChanging(false);
    }
  };

  useEffect(() => {
    const socket = new WebSocket(process.env.REACT_APP_WS_URL);

    socket.onopen = () => {
      const token = localStorage.getItem("token");
      if (token) {
        socket.send(JSON.stringify({ type: "auth", token }));
      }
    };

    socket.onmessage = (event) => {
      try {
        const data = JSON.parse(event.data);
        if (data.event === "receive_message") {
          if (Array.isArray(data.rows)) {
            setNotifications((prev) => [...data.rows, ...prev]);
          }
          fetchCount();
        }
        if (data.event === "notification_count") {
          setUnreadCount(data.count || 0);
        }
      } catch (err) {
        console.error("Socket parse error:", err);
      }
    };

    socket.onclose = () => {};

    return () => {
      socket.close();
    };
  }, []);

  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [showInstall, setShowInstall] = useState(true);

  useEffect(() => {
    const handler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      setShowInstall(true);
    };
    window.addEventListener("beforeinstallprompt", handler);
    return () => {
      window.removeEventListener("beforeinstallprompt", handler);
    };
  }, []);

  const handleInstallClick = async () => {
    if (!deferredPrompt) {
      alert(
        "Install prompt not available. Try in Chrome/Edge on localhost or HTTPS.",
      );
      return;
    }
    deferredPrompt.prompt();
    const { outcome } = await deferredPrompt.userChoice;
    if (outcome === "accepted") {
      alert("App installed successfully ✅");
    } else {
      alert("Installation dismissed ❌");
    }
    setDeferredPrompt(null);
    setShowInstall(false);
  };

  return (
    <div className="header" id="header">
      <div className="d-flex justify-content-between px-2 w-100 gap-1">
        {/* 🔴 LEFT SIDE */}
        <div className="header-left d-flex align-items-center gap-2">
          {/* Toggle */}
          <div className="togglebutton" onClick={onToggleSidebar}>
            <AiOutlineMenu />
          </div>

          {/* Logo — Mobile Only */}
          <div className="logo-box d-xl-none d-md-none d-sm-block">
            <Link className="logo-light" to="/dashboard">
              <img
                src={`${process.env.PUBLIC_URL}/assets/images/logo.png`}
                alt="logo"
                className="logo-lg"
              />
            </Link>
          </div>

          {/* Wallet Ledger */}
          <div className="desktop-show">
            <div className="d-flex align-items-center flex-wrap gap-2">
              {localStorage.getItem("userType") === "admin" && (
                <div className="wallet">
                  <div className="credit_amount">
                    <Link
                      to="/admin-wallet-report"
                      className="gap-2 wallet-link d-flex align-items-center text-decoration-none"
                    >
                      <div className="walletimage">
                        <img src={wallet} alt="wallet" />
                      </div>
                      <div className="text-dark">
                        <div className="referdetailscontent text-center">
                          <p className="mb-1 d-none d-md-block">Wallet Ledger</p>
                        </div>
                      </div>
                    </Link>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>

        {/* 🔴 RIGHT SIDE */}
        <div className="linksmode">
          {/* Bell */}
          {localStorage.getItem("userType") === "admin" && (
            <div className="d-xl-block position-relative">
              <div
                className="allheader border-0"
                onClick={handleBellClick}
                style={{ cursor: "pointer" }}
              >
                <FaBell />
                <span className="badge bg-danger position-absolute top-0 start-100 translate-middle">
                  {unreadCount ?? 0}
                </span>
              </div>
            </div>
          )}

          {/* Profile */}
          <div className="profilie" ref={dropdownRef}>
            <div className="profile-header" onClick={toggleDropdown}>
              <div className="profileimage">
                <img
                  src={
                    profile?.avatar ||
                    `${process.env.PUBLIC_URL}/assets/images/avatar-1.jpg`
                  }
                  alt="Admin"
                  onError={(e) => {
                    e.target.src = `https://ui-avatars.com/api/?name=Admin&background=1e5799&color=fff&bold=true`;
                  }}
                />
              </div>
              <div className="name desktop_device">
                {name || userEmail?.split("@")[0] || "Admin"}
              </div>
              <div
                className={`arrowprofile transition-transform duration-300 ${
                  dropdownOpen ? "rotate-180" : ""
                }`}
              >
                <IoIosArrowDown />
              </div>
            </div>

            {dropdownOpen && (
              <div className="profile-dropdown">
                {/* User Info — Mobile Only */}
                <div className="dropdown-item mobile_device">
                  <div className="d-flex gap-2 align-items-center">
                    <div className="profileimage">
                      <img
                        src={`https://ui-avatars.com/api/?name=Admin&background=1e5799&color=fff&bold=true`}
                        alt="Admin"
                      />
                    </div>
                    <div className="name">
                      {name || userEmail?.split("@")[0] || "Admin"}
                    </div>
                  </div>
                </div>

                {/* Install App — Mobile Only */}
                {showInstall && (
                  <div
                    className="dropdown-item d-flex align-items-center gap-2 mobile-pwa"
                    onClick={handleInstallClick}
                  >
                    <FiDownload />
                    Install App
                  </div>
                )}

                {/* Profile */}
                <div
                  className="dropdown-item d-flex align-items-center gap-2"
                  onClick={handleShowProfileModal}
                >
                  <FiUser />
                  Profile
                </div>

                {/* Change Password */}
                <div
                  className="dropdown-item d-flex align-items-center gap-2"
                  onClick={handleShowChangePasswordModal}
                >
                  <FiLock />
                  Change Password
                </div>

                {/* Logout */}
                <div
                  className="dropdown-item d-flex align-items-center gap-2 text-danger fw-bold"
                  onClick={handleLogout}
                >
                  <FiLogOut />
                  Logout
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Profile Modal */}
      <Modal show={showProfileModal} onHide={handleCloseProfileModal} centered>
        <Modal.Header
          closeButton
          style={{
            background: "linear-gradient(135deg, #1e5799, #2b6cb0)",
            color: "#ffffff",
            borderTopLeftRadius: "12px",
            borderTopRightRadius: "12px",
            borderBottom: "none",
            padding: "16px 20px",
          }}
        >
          <Modal.Title
            style={{
              fontSize: "18px",
              fontWeight: "700",
              letterSpacing: "-0.3px",
            }}
          >
            👤 Profile Information
          </Modal.Title>
        </Modal.Header>

        <Modal.Body style={{ padding: "24px" }}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "16px",
              marginBottom: "24px",
              paddingBottom: "20px",
              borderBottom: "1.5px solid #e2e8f0",
            }}
          >
            <img
              src={`https://ui-avatars.com/api/?name=${encodeURIComponent(
                name || "Admin",
              )}&background=1e5799&color=fff&bold=true&size=80`}
              alt="Admin"
              style={{
                width: "70px",
                height: "70px",
                borderRadius: "50%",
                border: "3px solid #e2e8f0",
                boxShadow: "0 4px 12px rgba(30, 87, 153, 0.15)",
              }}
              onError={(e) => {
                e.target.src = `https://ui-avatars.com/api/?name=Admin&background=1e5799&color=fff&bold=true&size=80`;
              }}
            />
            <div>
              <h5
                style={{
                  margin: 0,
                  fontSize: "18px",
                  fontWeight: "700",
                  color: "#1e3a5f",
                }}
              >
                {name || userEmail?.split("@")[0] || "Admin"}
              </h5>
              <p
                style={{
                  margin: "4px 0 0",
                  fontSize: "13px",
                  color: "#64748b",
                  fontWeight: "500",
                }}
              >
                {userEmail || "—"}
              </p>
              <span
                style={{
                  display: "inline-block",
                  marginTop: "6px",
                  padding: "3px 10px",
                  borderRadius: "20px",
                  fontSize: "11px",
                  fontWeight: "700",
                  background: "linear-gradient(135deg, #1e5799, #2b6cb0)",
                  color: "#ffffff",
                  letterSpacing: "0.5px",
                }}
              >
                ADMIN
              </span>
            </div>
          </div>

          <Form>
            <Form.Group className="mb-3" controlId="userNameDisplay">
              <Form.Label
                style={{
                  fontSize: "12.5px",
                  fontWeight: "700",
                  color: "#1e3a5f",
                  marginBottom: "6px",
                  display: "flex",
                  alignItems: "center",
                  gap: "6px",
                }}
              >
                👤 Name
              </Form.Label>
              <Form.Control
                type="text"
                value={name || userEmail?.split("@")[0] || "Admin"}
                readOnly
                style={{
                  borderRadius: "10px",
                  padding: "10px 14px",
                  fontSize: "14px",
                  fontWeight: "600",
                  color: "#1e3a5f",
                  background: "#f8fafc",
                  border: "1.5px solid #e2e8f0",
                }}
              />
            </Form.Group>

            <Form.Group className="mb-2" controlId="userEmailDisplay">
              <Form.Label
                style={{
                  fontSize: "12.5px",
                  fontWeight: "700",
                  color: "#1e3a5f",
                  marginBottom: "6px",
                  display: "flex",
                  alignItems: "center",
                  gap: "6px",
                }}
              >
                ✉️ Email
              </Form.Label>
              <Form.Control
                type="text"
                value={userEmail || "—"}
                readOnly
                style={{
                  borderRadius: "10px",
                  padding: "10px 14px",
                  fontSize: "14px",
                  fontWeight: "600",
                  color: "#1e3a5f",
                  background: "#f8fafc",
                  border: "1.5px solid #e2e8f0",
                }}
              />
            </Form.Group>
          </Form>
        </Modal.Body>

        <Modal.Footer
          style={{
            borderTop: "1.5px solid #e2e8f0",
            padding: "16px 24px",
            background: "#f8fafc",
            borderBottomLeftRadius: "12px",
            borderBottomRightRadius: "12px",
          }}
        >
          <Button
            onClick={handleCloseProfileModal}
            style={{
              borderRadius: "10px",
              fontWeight: "700",
              padding: "9px 24px",
              background: "linear-gradient(135deg, #1e5799, #2b6cb0)",
              border: "none",
              color: "#ffffff",
              boxShadow: "0 4px 12px rgba(30, 87, 153, 0.25)",
            }}
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Change Password Modal */}
      <Modal
        show={showChangePasswordModal}
        onHide={handleCloseChangePasswordModal}
        centered
      >
        <Modal.Header
          closeButton
          style={{
            background: "linear-gradient(135deg, #1e5799, #2b6cb0)",
            color: "#ffffff",
            borderTopLeftRadius: "12px",
            borderTopRightRadius: "12px",
            borderBottom: "none",
            padding: "16px 20px",
          }}
        >
          <Modal.Title
            style={{
              fontSize: "18px",
              fontWeight: "700",
              letterSpacing: "-0.3px",
            }}
          >
            🔒 Change Password
          </Modal.Title>
        </Modal.Header>

        <Modal.Body style={{ padding: "24px" }}>
          <div
            style={{
              display: "flex",
              alignItems: "flex-start",
              gap: "10px",
              padding: "12px 14px",
              borderRadius: "10px",
              background: "linear-gradient(135deg, #eff6ff, #e6f0fa)",
              border: "1.5px solid #dbeafe",
              marginBottom: "20px",
            }}
          >
            <span style={{ fontSize: "18px", lineHeight: "1" }}>💡</span>
            <p
              style={{
                margin: 0,
                fontSize: "12.5px",
                color: "#1e3a5f",
                fontWeight: "500",
                lineHeight: "1.5",
              }}
            >
              Password must be at least <strong>6 characters</strong> long.
              Choose a strong password to keep your account secure.
            </p>
          </div>

          <Form onSubmit={handleChangePassword}>
            <Form.Group className="mb-3" controlId="newPassword">
              <Form.Label
                style={{
                  fontSize: "12.5px",
                  fontWeight: "700",
                  color: "#1e3a5f",
                  marginBottom: "6px",
                  display: "flex",
                  alignItems: "center",
                  gap: "6px",
                }}
              >
                🔑 New Password <span className="text-danger">*</span>
              </Form.Label>
              <div style={{ position: "relative" }}>
                <Form.Control
                  type={showNewPassword ? "text" : "password"}
                  value={newPassword}
                  onChange={(e) => {
                    setNewPassword(e.target.value);
                    if (passwordErrors.newPassword)
                      setPasswordErrors((prev) => ({
                        ...prev,
                        newPassword: null,
                      }));
                  }}
                  isInvalid={!!passwordErrors.newPassword}
                  placeholder="Enter new password"
                  style={{
                    borderRadius: "10px",
                    padding: "10px 40px 10px 14px",
                    fontSize: "14px",
                    fontWeight: "500",
                    color: "#1e3a5f",
                    border: "1.5px solid #e2e8f0",
                  }}
                />
                <span
                  onClick={() => setShowNewPassword(!showNewPassword)}
                  style={{
                    position: "absolute",
                    top: "50%",
                    right: "14px",
                    transform: "translateY(-50%)",
                    cursor: "pointer",
                    fontSize: "16px",
                    color: "#64748b",
                    userSelect: "none",
                  }}
                >
                  {showNewPassword ? "🙈" : "👁️"}
                </span>
              </div>
              <Form.Control.Feedback type="invalid">
                {passwordErrors.newPassword}
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group className="mb-3" controlId="confirmNewPassword">
              <Form.Label
                style={{
                  fontSize: "12.5px",
                  fontWeight: "700",
                  color: "#1e3a5f",
                  marginBottom: "6px",
                  display: "flex",
                  alignItems: "center",
                  gap: "6px",
                }}
              >
                🔐 Confirm New Password <span className="text-danger">*</span>
              </Form.Label>
              <div style={{ position: "relative" }}>
                <Form.Control
                  type={showConfirmPassword ? "text" : "password"}
                  value={confirmNewPassword}
                  onChange={(e) => {
                    setConfirmNewPassword(e.target.value);
                    if (passwordErrors.confirmNewPassword)
                      setPasswordErrors((prev) => ({
                        ...prev,
                        confirmNewPassword: null,
                      }));
                  }}
                  isInvalid={!!passwordErrors.confirmNewPassword}
                  placeholder="Confirm new password"
                  style={{
                    borderRadius: "10px",
                    padding: "10px 40px 10px 14px",
                    fontSize: "14px",
                    fontWeight: "500",
                    color: "#1e3a5f",
                    border: "1.5px solid #e2e8f0",
                  }}
                />
                <span
                  onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                  style={{
                    position: "absolute",
                    top: "50%",
                    right: "14px",
                    transform: "translateY(-50%)",
                    cursor: "pointer",
                    fontSize: "16px",
                    color: "#64748b",
                    userSelect: "none",
                  }}
                >
                  {showConfirmPassword ? "🙈" : "👁️"}
                </span>
              </div>
              <Form.Control.Feedback type="invalid">
                {passwordErrors.confirmNewPassword}
              </Form.Control.Feedback>
            </Form.Group>

            {newPassword && confirmNewPassword && (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  fontSize: "12.5px",
                  fontWeight: "600",
                  marginBottom: "4px",
                  color:
                    newPassword === confirmNewPassword ? "#16a34a" : "#dc2626",
                }}
              >
                {newPassword === confirmNewPassword ? (
                  <>✅ Passwords match</>
                ) : (
                  <>❌ Passwords do not match</>
                )}
              </div>
            )}
          </Form>
        </Modal.Body>

        <Modal.Footer
          style={{
            borderTop: "1.5px solid #e2e8f0",
            padding: "16px 24px",
            background: "#f8fafc",
            borderBottomLeftRadius: "12px",
            borderBottomRightRadius: "12px",
            display: "flex",
            gap: "10px",
            justifyContent: "flex-end",
          }}
        >
          <Button
            variant="secondary"
            onClick={handleCloseChangePasswordModal}
            style={{
              borderRadius: "10px",
              fontWeight: "700",
              padding: "9px 20px",
              background: "#ffffff",
              border: "1.5px solid #e2e8f0",
              color: "#1e3a5f",
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleChangePassword}
            disabled={isPasswordChanging}
            style={{
              borderRadius: "10px",
              fontWeight: "700",
              padding: "9px 24px",
              background: "linear-gradient(135deg, #1e5799, #2b6cb0)",
              border: "none",
              color: "#ffffff",
              boxShadow: "0 4px 12px rgba(30, 87, 153, 0.25)",
              cursor: isPasswordChanging ? "not-allowed" : "pointer",
              opacity: isPasswordChanging ? 0.7 : 1,
            }}
          >
            {isPasswordChanging ? (
              <>
                <span
                  className="spinner-border spinner-border-sm me-2"
                  role="status"
                  aria-hidden="true"
                ></span>
                Changing...
              </>
            ) : (
              "Change Password"
            )}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* 🎯 TOAST NOTIFICATION (top-right) */}
      {toast.show && (
        <div
          style={{
            position: "fixed",
            top: "80px",
            right: "20px",
            zIndex: 99999,
            minWidth: "320px",
            maxWidth: "420px",
            background: "#ffffff",
            borderRadius: "12px",
            boxShadow: "0 12px 40px rgba(0,0,0,0.18)",
            overflow: "hidden",
            animation: "toastSlideIn 0.35s ease-out",
            border: "1px solid #e2e8f0",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "flex-start",
              gap: "12px",
              padding: "14px 16px",
            }}
          >
            {/* Icon */}
            <div
              style={{
                width: "38px",
                height: "38px",
                borderRadius: "50%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: "18px",
                flexShrink: 0,
                background:
                  toast.type === "success"
                    ? "#dcfce7"
                    : toast.type === "error"
                      ? "#fee2e2"
                      : "#fef3c7",
                color:
                  toast.type === "success"
                    ? "#16a34a"
                    : toast.type === "error"
                      ? "#dc2626"
                      : "#f59e0b",
              }}
            >
              {toast.type === "success"
                ? "✓"
                : toast.type === "error"
                  ? "✕"
                  : "!"}
            </div>

            {/* Content */}
            <div style={{ flex: 1, minWidth: 0 }}>
              <div
                style={{
                  fontSize: "14px",
                  fontWeight: "700",
                  color: "#1e3a5f",
                  marginBottom: "2px",
                }}
              >
                {toast.title}
              </div>
              <div
                style={{
                  fontSize: "12.5px",
                  color: "#64748b",
                  fontWeight: "500",
                  lineHeight: "1.4",
                  wordBreak: "break-word",
                }}
              >
                {toast.text}
              </div>
            </div>

            {/* Close */}
            <button
              onClick={() =>
                setToast({ show: false, title: "", text: "", type: "success" })
              }
              style={{
                background: "transparent",
                border: "none",
                color: "#94a3b8",
                fontSize: "18px",
                fontWeight: "700",
                cursor: "pointer",
                lineHeight: "1",
                padding: 0,
                marginLeft: "4px",
              }}
              aria-label="Close"
            >
              ✕
            </button>
          </div>

          {/* Progress bar */}
          <div
            style={{
              height: "3px",
              background: "#f1f5f9",
              overflow: "hidden",
            }}
          >
            <div
              style={{
                height: "100%",
                background:
                  toast.type === "success"
                    ? "#16a34a"
                    : toast.type === "error"
                      ? "#dc2626"
                      : "#f59e0b",
                animation: "toastBar 5s linear forwards",
              }}
            />
          </div>
        </div>
      )}

      {/* Left border accent */}
      <style>{`
        @keyframes toastSlideIn {
          from {
            transform: translateX(120%);
            opacity: 0;
          }
          to {
            transform: translateX(0);
            opacity: 1;
          }
        }
        @keyframes toastBar {
          from { width: 100%; }
          to { width: 0%; }
        }
      `}</style>

      {/* Message Modal (for confirm actions only - keep old) */}
      {showMessageModal && (
        <div
          className="modal d-block"
          tabIndex="-1"
          style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
        >
          <div className="modal-dialog modal-dialog-centered">
            <div
              className={`modal-content ${
                messageModalContent.type === "success" ? "border-success" : ""
              }`}
            >
              <div className="modal-header d-flex justify-content-between align-items-center">
                <h5
                  className={`modal-title ${
                    messageModalContent.type === "success"
                      ? "text-success"
                      : messageModalContent.type === "error"
                        ? "text-danger"
                        : "text-warning"
                  }`}
                >
                  {messageModalContent.title}
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  aria-label="Close"
                  onClick={closeCustomMessageModal}
                ></button>
              </div>
              <div className="modal-body text-secondary">
                <p>{messageModalContent.text}</p>
              </div>
              <div className="modal-footer justify-content-center">
                {messageModalContent.confirmAction ? (
                  <>
                    <Button
                      variant="secondary"
                      onClick={closeCustomMessageModal}
                    >
                      Cancel
                    </Button>
                    <Button
                      variant={
                        messageModalContent.type === "warning"
                          ? "warning"
                          : "primary"
                      }
                      onClick={() => {
                        messageModalContent.confirmAction();
                        closeCustomMessageModal();
                      }}
                    >
                      Confirm
                    </Button>
                  </>
                ) : (
                  <Button
                    variant={
                      messageModalContent.type === "success"
                        ? "success"
                        : messageModalContent.type === "error"
                          ? "danger"
                          : "primary"
                    }
                    onClick={closeCustomMessageModal}
                  >
                    OK
                  </Button>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Header;